import React, { useCallback, useState } from "react";
import {
    removeIsDowntimeDetailsInput,
    resetFailureDetails,
    setIsDowntimeDetailsInput,
    setSplitInProgress,
} from "../../utilities/storageUtilities";
import { initialState, MachineCenterContext } from "./MachineCenterContext";
import { IMachineCenterProps } from "./MachineCenterInterfaces";

export const MachineCenterProvider: React.FC<IMachineCenterProps> = ({ children }) => {
    const [machineStatus, setMachineStatus] = useState(initialState.machineStatus);
    const [continueDowntimeDetailsInput, setContinueDowntimeDetailsInput] = useState(
        initialState.continueDowntimeDetailsInput,
    );
    const [downtimeCounter, setDowntimeCounter] = useState(initialState.downtimeCounter);
    const [downtimeCounterBelowTrigger, setDowntimeCounterBelowTrigger] = useState(
        initialState.downtimeCounterBelowTrigger,
    );
    const [plc, setPlc] = useState(initialState.plc);
    const [splitInProgress, setSplitInProgressState] = useState(initialState.splitInProgress);

    const handleMachineStatus = useCallback((status: boolean, reset: boolean = true) => {
        setMachineStatus(status);
        if (status && reset) {
            resetFailureDetails();
        }
    }, []);

    const handleContinueDowntimeDetailsInput = useCallback((value: boolean) => {
        setContinueDowntimeDetailsInput(value);
        if (value) {
            setIsDowntimeDetailsInput(value);
        } else {
            removeIsDowntimeDetailsInput();
        }
    }, []);

    const handleDowntimeCounter = useCallback((value: boolean) => {
        setDowntimeCounter(value);
    }, []);

    const handleDowntimeCounterBelowTrigger = useCallback((value: boolean) => {
        setDowntimeCounterBelowTrigger(value);
    }, []);

    const handlePlc = useCallback((value: boolean) => {
        setPlc(value);
    }, []);

    const handleSplitInProgress = useCallback((value: boolean) => {
        setSplitInProgressState(value);
        setSplitInProgress(value);
    }, []);

    const handleResetMachineCenterContext = useCallback(() => {
        handleMachineStatus(initialState.machineStatus);
        handleDowntimeCounter(initialState.downtimeCounter);
        handleDowntimeCounterBelowTrigger(initialState.downtimeCounterBelowTrigger);
        handlePlc(initialState.plc);
        handleContinueDowntimeDetailsInput(false);
        handleSplitInProgress(initialState.splitInProgress);
    }, [
        handleDowntimeCounter,
        handleDowntimeCounterBelowTrigger,
        handleMachineStatus,
        handlePlc,
        handleContinueDowntimeDetailsInput,
        handleSplitInProgress,
    ]);

    const providerValue = {
        machineStatus,
        handleMachineStatus,
        handleResetMachineCenterContext,
        downtimeCounter,
        handleDowntimeCounter,
        downtimeCounterBelowTrigger,
        handleDowntimeCounterBelowTrigger,
        plc,
        handlePlc,
        continueDowntimeDetailsInput,
        handleContinueDowntimeDetailsInput,
        splitInProgress,
        handleSplitInProgress,
    };

    return <MachineCenterContext.Provider value={providerValue}>{children}</MachineCenterContext.Provider>;
};
